// import i18n from './lang/i18n'
import helper from '@/Helper'
import router from '@/router'

export function handleServerError (res) {
  const status = res.status
  if (status === 403 || status === 401) {
    helper.clearLocalStorage()
    router.push('/login')
  }
  if (status === 404) {
    router.push('/404')
  }
  if (status === 400) {
    const mess = res.data.message
    this.$notify({
      title: mess
    })
  }
  // handle other statuses...
}



// WEBPACK FOOTER //
// ./src/service/ErrorHandlering.js